import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ApiRequest, BaseCategoryTypeEnum, IApiresponse, LogObjectActionTemplateEnum } from 'src/app/_models';
import { LoggingPanelModel } from 'src/app/_models/common/LoggingPanelModel';
import { AlertPanelModel } from 'src/app/_models/common/alertPanelModel';
import { Claims } from 'src/app/_models/common/claims';
import { IManageCategoryAddUpdateResponse } from 'src/app/_models/manage-category/manage-category-add-update-response';
import { IManageCategoryListResponse } from 'src/app/_models/manage-category/manage-category-list-response';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { LoggingPanelService } from 'src/app/_services/logging-panel/logging-panel.service';
import { ManageCategoryService } from 'src/app/_services/manage-category/manage-category.service';
import { environment } from 'src/environments/environment';
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { SetupTypeEnum } from 'src/app/_models';
import { SetupTypeCategories } from 'src/app/_models';

@Component({
  selector: 'app-add-vendor-category-panel',
  templateUrl: './add-vendor-category-panel.component.html',
  standalone: false
})
export class AddVendorCategoryPanelComponent {
  howDoIVideoLinks = HowDoIVideoLinks;
  @Input() categoryFormModel: any = {};
  @Output() closePanelEvent = new EventEmitter<any>();
  claims: Claims;
  requestInfo: any = {};
  claimsSubscription: Subscription;
  taxRateList = [];
  expenseCategoryName: string;
  accCostCode: string;
  hasFormChanges: boolean = false;
  vendorCategory: any = {};
  get activeCatButtonText(): string{
    return this.vendorCategory.isActive ? this.translate.instant('turn_off') : this.translate.instant('turn_on');
  }
  alertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
  popUpModelAlertHeading: string;
  popUpModelAlertContant: string;
  isNameEmpty: boolean = false;
  isEditView: boolean = false;

  constructor(private _loggingPanelService: LoggingPanelService,
    private claimsService: ClaimsService,private translate: TranslateService,
    private manageCategoryService: ManageCategoryService
  ){
    this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
  });
  }

  ngOnInit() {
    if(this.categoryFormModel)
    {
      
      let selectedCategory = this.categoryFormModel.manageCategoryList.find(a => a.orgExpenseCategoryId == this.categoryFormModel.orgExpenseCategoryId);
      if(selectedCategory == undefined || selectedCategory == null){
        this.isEditView = false;
      }
      else {
      this.isEditView = true;
      }
      this.taxRateList = this.categoryFormModel.vatRateItems.filter(a => a.id != 0.01 && a.id != 0.02);
      this.initialiseForm(selectedCategory);
    }
    
  }
  
  get isAddNewCategory() {
    return (this.categoryFormModel.orgExpenseCategoryId == null || this.categoryFormModel.orgExpenseCategoryId == undefined);
  }
  
  onClosePanel() {
    if(this.hasFormChanges){
      this.popUpModelAlertContant = this.translate.instant('business_purpose_discard_msg');
      this.popUpModelAlertHeading = this.translate.instant('label_confirm');
      this.fnOpenAlertWithMessages()
    }
    else{
      this.categoryFormModel =[];
      this.closePanelEvent.emit(false);
    }
  }
  
  fnShowConfigureshowLoggingAlertPanel() {
    const model = new LoggingPanelModel(
      this.claims.OrgId.toString(),
      LogObjectActionTemplateEnum.VendorCategory.toString(),
      this.categoryFormModel.orgExpenseCategoryId
    );
    this._loggingPanelService.onShowLogPanel(model);
  }

  onCategoryNameChange(event){
    this.isNameEmpty = false;
    this.hasFormChanges = true;
  }

  onAccCostCodeChange(event){
    this.hasFormChanges = true;
  }

  onTaxRateChange(event){
    this.hasFormChanges = true;
  }

  onAdditionalFieldsChange(sequence){
    this.hasFormChanges = true;
  }

serverError: any;
  fnSaveExpenseCategory(){
    if(this.vendorCategory.expenseCategoryName.trim() == ''){
      this.isNameEmpty = true;
      this.hasFormChanges = false;
      this.vendorCategory.expenseCategoryName = '';
      return;
    }
    let request = new ApiRequest<IManageCategoryListResponse>(
      "SoloAddUpdateVendorOrgCategory",
      environment.applicationVersion,
      environment.requestId
    );
    request.requestInfo = this.vendorCategory;
    request.requestInfo.type = SetupTypeCategories.VendorCategory;
    localStorage.setItem("categoryUpdatedDateTime" + this.claims.OrgId, JSON.stringify(new Date().toUTCString()));
    this.manageCategoryService
      .SoloAddUpdateVendorOrgCategory(request)
      .subscribe((res: IApiresponse<IManageCategoryAddUpdateResponse>) => {
        let result = res;
        if (result.statusCode == 0) {
          this.serverError = '';
          this.closePanelEvent.emit({close: true, subCatId: res.responseInfo});
        } 
        else {
          let error = result.errorInfo.filter((it) => it.errorCode == "DC001");
          if (error.length > 0) {
            if (error[0].errorCode == "DC001") {
              this.serverError = this.translate.instant("manageCat_catNameDuplicate_msg");
            }
          }
          error = result.errorInfo.filter((it) => it.errorCode == "SW001");
          if (error.length > 0) {
            if (error[0].errorCode == "SW001") {
            }
          }
        }
        

      });
  }
  
  onIsCatActiveChange(){
    this.vendorCategory.isActive = !this.vendorCategory.isActive;
    this.hasFormChanges = true;
  }

  initialiseForm(category = null){
    if(category != null){
      this.vendorCategory = category;
    }
    else{
      this.vendorCategory.expenseCategoryName = '';
      this.vendorCategory.accountingCode = '';
      this.vendorCategory.taxRateMasterId = '';
      this.vendorCategory.baseCategoryId = BaseCategoryTypeEnum.Generic;
      this.vendorCategory.isActive = true;
    }
  }

  fnOpenAlertWithMessages() {
    this.alertPanelModel = new AlertPanelModel(
      true,
      this.popUpModelAlertHeading,
      [this.popUpModelAlertContant],
      this.translate.instant("cancel"),
      this.translate.instant("label_confirm"),
      true,
      this.translate.instant("please_review_or_confirm")
    );
  }
  
  alertPanelReceiver(returnValue) {
    if (returnValue) {
      this.closePanelEvent.emit(false);
    }
    this.alertPanelModel = new AlertPanelModel(false, "", [""], "", "", true, this.translate.instant("please_review_or_confirm"));
  }
}
